/*=========================================================================================
  File Name: module-customsdeclaration-actions.js
  Description: CustomsDeclaration Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: DQDUY
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import CustomsDeclarationAPI from '@/api/CustomsDeclarationAPI.js';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { MSEnum } from '../../common/enumeration';
import i18n from '@/i18n/i18n';
import DownloadAPI from '@/api/DownloadAPI.js';
export default {
    /**
     * Lấy danh sách hóa đơn đầu ra theo paging
     */
    loadCustomsDeclaration: async function(context, payload) {
        let res = await httpClient.postAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/pagging`,
                data: payload
            },
            true
        );
        if (res && res.Success) {
            context.commit('updateCustomsDeclaration', { data: res.Data, isGetTotal: payload.IsGetTotal });
        }
        return null;
    },

    /**
     * Lấy chi tiết tờ khai hải quan
     * @author dqduy 31.01.2024
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    getDeclarationById: async function(context, payload) {
        let res = await httpClient.getAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}`
            },
            true
        );

        if (res && res.Success) {
            return res.Data;
        }
        return null;
    },

    /**
     * tổng số bản ghi
     */
    getTotalPageAsync: async function(context, payload) {
        let res = await httpClient.postAsync({
            url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
            data: payload
        });

        if (res && res.Success) {
            context.commit('updateTotalPage', res.Data);
        }
        return 0;
    },

    /**
     * Kiểm tra lại 1 tờ khai hải quan
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    checkAgain: async function(context, payload) {
        return await httpClient.getAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload}/checkagain`,
                timeout: window.__env.appSetting.timeoutCheckAgain
            },
            true
        );
    },

    /**
     * Xóa hoặc khôi phục tờ khai
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    trashDeclarationAsync: async function(context, payload) {
        return await httpClient.postAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trash`,
                params: payload
            },
            true
        );
    },

    /**
     * Xóa nhiều tờ khai hải quan cùng lúc (batch delete)
     * @param {*} context - Vuex context
     * @param {Array} declarationIds - Danh sách ID các tờ khai cần xóa
     * @returns {Promise<Object>} Response object chứa Success flag và Data (danh sách tờ khai đã xóa)
     * @author dqduy 06.02.2025
     */
    trashDeclarationBatchAsync: async function(context, declarationIds) {
        return await httpClient.postAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/trashs`,
                data: declarationIds
            },
            true
        );
    },

    /**
     * Xóa hoặc khôi phục tờ khai
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    restoreDeclarationAsync: async function(context, payload) {
        return await httpClient.postAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/restore`,
                params: payload
            },
            true
        );
    },

    /**
     * Hàm điều chuyển tờ khai
     * @returns
     */
    moveDeclaration: async function(context, payload) {
        return await httpClient.postAsync({
                url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/move`,
                data: payload
            },
            true
        );
    },

    /**
     * In kết quả kiểm tra
     */
    printManyPdfFile: async function(context, payload) {
        let titleProcess = `${i18n.t('i18nCommon.PrintDeclaration')}`.toLowerCase();
        let fileName = payload.fileName ? `${payload.fileName}.pdf` : 'tokhai.pdf';
        let ProgressData = {
            percentCompleted: 0,
            fileName: fileName,
            Success: true
        };
        if (payload.fileName) {
            ProgressData.fileName = `${payload.fileName}.pdf`;
        }
        EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData, titleProcess);
        let res = await httpClient.postAsync({
            url: CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/print-many-pdf`,
            data: payload
        });
        if (res && res.Success) {
            let tryTime = 0;
            async function download(key) {
                tryTime++;
                let downloaded = await httpClient.getAsync({
                    url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/download-pdf-print`,
                    responseType: 'arraybuffer'
                });
                if (downloaded instanceof ArrayBuffer) {
                    ProgressData = {
                        percentCompleted: 100,
                        fileName: fileName,
                        Success: true
                    };
                    EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData, titleProcess);
                    commonFunc.openByBlob(downloaded, 'application/pdf', `${fileName}`);
                } else {
                    if (tryTime >= NumberRetry) {
                        ProgressData = {
                            percentCompleted: 0,
                            fileName: fileName,
                            Success: false
                        };
                        EventBusGlobal.$emit(
                            GlobalEventName.Progress,
                            ProgressData,
                            `${i18n.t('i18nCommon.PrintDeclaration')}`
                        );
                        return;
                    }
                    setTimeout(() => {
                        download(key);
                    }, NumberTimeOutRetry);
                }
            }
            setTimeout(() => {
                download(res.Data.Key);
            }, NumberTimeOutRetry);
            return res;
        } else {
            ProgressData = { percentCompleted: 0, fileName: 'tokhai.pdf', Success: false };
            EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData, `${i18n.t('i18nCommon.PrintDeclaration')}`);
            return null;
        }
    },

    /**
     * Lấy tổng tiền chân trang tờ khai hải quan
     * @param {*} context
     * @param {*} payload
     * @returns
     */
    getTotalAmountPageAsync: async function(context, payload) {
        //PDDang note: Thực hiện gọi mutiation chung để update loading => (tên mutation: updateLoadingTotalAmountPage, giá trị , root)
        context.commit('updateLoadingTotalAmountPage', true, { root: true });
        let res = await httpClient.postAsync({
                url: `${CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalamountpage`,
                data: payload
            },
            false
        );
        context.commit('updateLoadingTotalAmountPage', false, { root: true });
        if (res && res.Data) {
            return res.Data;
        }
        return null;
    },

    /**
     * Tải file excel/xml gốc của tờ khai hải quan
     * @param {Object} context - Vuex context
     * @param {Object} payload
     * @param {string} payload.declarationId
     * @param {string} payload.declarationNo - Số tờ khai
     * @param {string} payload.declarationDate - Ngày tờ khai (ISO string)
     * @returns {Promise<void>}
     * @author DQDUY 13/06/2026
     */
    downloadOriginalFile: async function(context, { declarationId, declarationNo, declarationDate, fileExtension }) {
        try {
            let downloaded = await httpClient.getAsync({
                url: `${CustomsDeclarationAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/${declarationId}/download`,
                responseType: 'arraybuffer'
            });
            if (downloaded instanceof ArrayBuffer) {
                const ext = fileExtension || '.xlsx';
                let fileName = `ToKhaiHQ${ext}`;
                if (declarationNo && declarationDate) {
                    const datePart = commonFunc.formatDate(declarationDate, 'DDMMYYYY');
                    fileName = `ToKhaiHQ_${declarationNo}_${datePart}${ext}`;
                }
                
                const blob = new Blob([downloaded]);
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = downloadUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(a);
            }
        } catch {
            // Lỗi được xử lý bởi httpClient interceptor
        }
    },

    setSelectedDeclarations({ commit }, declarations) {
        commit('updateSelectedDeclarations', declarations);
    },

    /**
     * Xóa toàn bộ selection trong Vuex store
     * @param {Object} context - Vuex context
     * @author dqduy 09.02.2026
     */
    clearSelectedDeclarations({ commit }) {
        commit('clearSelectedDeclarations');
    }
};